import React from 'react';
import PropTypes from 'prop-types';
import styles from './loaderFullScreen.scss';

function LoaderFullScreen({ className }) {
  return (
    <div className={styles.loaderFullScreen}>
      <div
        className={`${styles.loaderContent}${className ? ` ${className}` : ''}`}
      >
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

LoaderFullScreen.propTypes = {
  className: PropTypes.string,
};

export default LoaderFullScreen;
